import { render, staticRenderFns } from "./tvs.vue?vue&type=template&id=b22954dc"
import script from "./tvs.vue?vue&type=script&lang=js"
export * from "./tvs.vue?vue&type=script&lang=js"
import style0 from "./tvs.vue?vue&type=style&index=0&id=b22954dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports